/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResourceState
 */
export interface ResourceState {
	/**
	 * RID of the resource
	 * @type {string}
	 * @memberof ResourceState
	 */
	rID: string;
	/**
	 * State information of the resource
	 * @type {object}
	 * @memberof ResourceState
	 */
	state: object;
}

/**
 * Check if a given object implements the ResourceState interface.
 */
export function instanceOfResourceState(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'state' in value;

	return isInstance;
}

export function ResourceStateFromJSON(json: any): ResourceState {
	return ResourceStateFromJSONTyped(json, false);
}

export function ResourceStateFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResourceState {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		state: json['state'],
	};
}

export function ResourceStateToJSON(value?: ResourceState | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		state: value.state,
	};
}
